// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const urlServer = '#{serverUrl}#';

export const MS_GRAPH_URL = 'https://graph.microsoft.com/v1.0'

export const environment = {
  production: false,
  clientId: '#{clientId}#',
  authority: '#{authority}#',
  URL_API: urlServer,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
